/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Collapse,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AnswersTable from "./AnswersTable";
import { useContext, useState } from "react";
import {
  QuestionnaireState,
  QuestionsContext,
} from "../../Context/questionsContext";
import AddImages from "./AddImages";
import { Vocabulary } from "../../Utils/Vocabulary";
import style from "./Questionnaire.module.scss";

type QuestionState = {
  questionNumber: number;
  answerText?: string;
  questions: Array<QuestionnaireState>;
  saveQuestionnaires: (e: any) => void;
};
const answerType = [
  {
    name: "singleChoice",
    label: Vocabulary.singleChoice,
  },
  {
    name: "multipleChoice",
    label: Vocabulary.multipleChoice,
  },
  {
    name: "slider",
    label: Vocabulary.slider,
  },
];
export default function Question(props: QuestionState) {
  const { questionNumber, questions, answerText, saveQuestionnaires } = props;
  const [openAddImagesModal, setOpenAddImagesModal] = useState(false);
  const questionsContext = useContext(QuestionsContext);

  /**
   *
   */
  function handleCloseOpenAddImagesModal() {
    setOpenAddImagesModal(false);
  }
  /**
   *
   * @param e
   */
  function handleChangeQuestionData(e: any) {
    const newQuestions: any = structuredClone(questions[questionNumber]);
    newQuestions[e.target.name] = e.target.value;
    questions[questionNumber] = newQuestions;
    //change state
    const newQuestionsContext = questionsContext.questions.slice();
    questionsContext.setQuestions(newQuestionsContext);
  }
  /**
   *
   * @param questionNumber
   */
  function handleChangeCollapse(questionNumber: number) {
    questions[questionNumber].openCollapse =
      !questions[questionNumber].openCollapse;
    //change state
    const newQuestions = questionsContext.questions.slice();
    questionsContext.setQuestions(newQuestions);
  }

  /**
   *
   * @param e
   */
  function handleChangeAnswerType(e: any) {
    questions[questionNumber].answerType = e.target.value;
    //change state
    const newQuestions = questionsContext.questions.slice();
    questionsContext.setQuestions(newQuestions);
  }

  /**
   *
   */
  function deleteQuestion() {
    questions.splice(questionNumber, 1);
    const newQuestions = questionsContext.questions.slice();
    questionsContext.setQuestions(newQuestions);
  }

  /**
   * Moves a question up or down in the array.
   *
   */
  function moveQuestion(index: number, position: number) {
    if (index === 0 && position < 0) return;
    if (index === questions.length - 1 && position > 0) return;

    const [removedQuestion] = questions.splice(index, 1);

    questions.splice(index + position, 0, removedQuestion);

    questionsContext.setQuestions([...questions]);
  }

  return (
    <div>
      <div className={style.questions}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {answerText ? null : (
            <div>
              <KeyboardArrowUpIcon
                className={style.btnIcon}
                onClick={() => moveQuestion(questionNumber, -1)}
                style={{
                  cursor: questionNumber === 0 ? "not-allowed" : "pointer",
                }}
              />
              <KeyboardArrowDownIcon
                className={style.btnIcon}
                onClick={() => moveQuestion(questionNumber, 1)}
                style={{
                  cursor:
                    questionNumber === questions.length - 1
                      ? "not-allowed"
                      : "pointer",
                }}
              />
            </div>
          )}
          <h2
            style={{ margin: 10 }}
            onClick={() => handleChangeCollapse(questionNumber)}
          >
            {answerText
              ? `${Vocabulary.answer} "${answerText}" - ${
                  Vocabulary.question
                } ${questionNumber + 1}`
              : ` ${Vocabulary.question} ${questionNumber + 1}`}
          </h2>
        </div>
        <div>
          <Button
            size="large"
            style={{
              margin: "0px 10px 30px 10px",
              verticalAlign: "center",
            }}
            onClick={() => setOpenAddImagesModal(true)}
          >
            {Vocabulary.addImages} (
            {questions[questionNumber].images
              ? questions[questionNumber].images.length
              : 0}
            )
          </Button>
          <DeleteIcon className={style.btnIcon} onClick={deleteQuestion} />
          {questions[questionNumber].openCollapse ? (
            <KeyboardArrowUpIcon
              className={style.btnIcon}
              onClick={() => handleChangeCollapse(questionNumber)}
            />
          ) : (
            <KeyboardArrowDownIcon
              className={style.btnIcon}
              onClick={() => handleChangeCollapse(questionNumber)}
            />
          )}
        </div>
      </div>
      <Collapse
        in={questions[questionNumber].openCollapse}
        unmountOnExit
        style={{ marginTop: -10 }}
      >
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            marginBottom: 20,
          }}
        >
          <ToggleButtonGroup
            value={questions[questionNumber].answerType}
            onChange={handleChangeAnswerType}
          >
            {answerType.map((at: any, index: number) => (
              <ToggleButton key={`answerType${index}`} value={at.name}>
                {at.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
          <div>
            {questions[questionNumber].answerType === "slider" ? (
              <div>
                <TextField
                  size="small"
                  type="number"
                  name="minValue"
                  label={Vocabulary.minValue}
                  style={{ marginRight: 10 }}
                  value={questions[questionNumber].minValue}
                  onChange={(e) => handleChangeQuestionData(e)}
                />
                <TextField
                  size="small"
                  type="number"
                  name="maxValue"
                  label={Vocabulary.maxValue}
                  value={questions[questionNumber].maxValue}
                  onChange={(e) => handleChangeQuestionData(e)}
                />
              </div>
            ) : null}
          </div>
        </div>
        <TextField
          type="text"
          name="question"
          label={Vocabulary.question}
          style={{ margin: "10px 0px" }}
          value={questions[questionNumber].question}
          onChange={(e) => handleChangeQuestionData(e)}
          required
          fullWidth
        />
        {questions[questionNumber].answers.length !== 0 ? (
          <AnswersTable
            answerType={questions[questionNumber].answerType}
            answers={questions[questionNumber].answers}
            saveQuestionnaires={(e: any) => saveQuestionnaires(e)}
          />
        ) : (
          ""
        )}
      </Collapse>
      <AddImages
        openModal={openAddImagesModal}
        handleCloseModal={handleCloseOpenAddImagesModal}
        state={questions[questionNumber]}
        saveQuestionnaires={saveQuestionnaires}
      />
    </div>
  );
}
